<template>
    <div class="col-sm-12">
        <div class="form-group">
            <span class="filter-icon"><i class="fa fa-calendar"></i></span>
            <label for="searchByColumn">
                <select id="searchByColumn"
                        class="form-control input-sm"
                        v-model="searchableColumn">
                    <option value disabled>- Choose a column -</option>
                    <option v-for="column in columns"
                            :key="column.idx" :value="column.prop">{{$t(`messages.${column.title}`)}}
                    </option>
                </select>
            </label>

            <span class="nowrap">
            <input type="text"
                   id="startDate"
                   class="form-control input-sm"
                   v-model="startDate"
                   placeholder="YYYY-MM-DD"
                   style="transform: translateY(1px)">

            <input type="text"
                   id="endDate"
                   class="form-control input-sm"
                   placeholder="YYYY-MM-DD"
                   v-model="endDate"
                   style="transform: translateY(1px)">
            </span>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      /**
       * An array of objects having following structure:
       * {title: colTitle, idx: columnIndex}
       */
      columns: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        searchableColumn: null,
        startDate: null,
        endDate: null
      }
    },
    computed: {
      /**
       * Query parameter for AJAX call
       * @return {{}}
       */
      q () {
        let q = {}
        if (this.startDate) {
          q[this.searchableColumn] = {
            after: this.startDate
          }
        }
        if (this.endDate) {
          q[this.searchableColumn]
            ? q[this.searchableColumn].before = this.endDate
            : q[this.searchableColumn] = {
              before: this.endDate
            }
        }

        return q
      }
    },
    methods: {
      getQuery () {
        return this.q
      },
      reset () {
        this.searchableColumn = null
        this.startDate = null
        this.endDate = null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/datatables/DateFilter.vue